import React from 'react';

const CLASSES = {
  PENDING: 'bg-yellow-50 text-yellow-800 border-yellow-200',
  APPROVED: 'bg-blue-50 text-blue-800 border-blue-200',
  REJECTED: 'bg-red-50 text-red-800 border-red-200',
  CANCELLED: 'bg-red-50 text-red-800 border-red-200',
  COMPLETED: 'bg-emerald-50 text-emerald-800 border-emerald-200',
  PAID: 'bg-emerald-50 text-emerald-800 border-emerald-200',
  UNPAID: 'bg-zinc-100 text-zinc-800 border-zinc-200',
  ACTIVE: 'bg-emerald-50 text-emerald-800 border-emerald-200',
  DISABLED: 'bg-zinc-100 text-zinc-600 border-zinc-200',
  DEFAULT: 'bg-zinc-100 text-zinc-800 border-zinc-200',
};

export default function StatusBadge({ status, className = '', testId }) {
  const s = String(status || 'DEFAULT').toUpperCase();
  const cls = CLASSES[s] || CLASSES.DEFAULT;
  return (
    <span
      data-testid={testId}
      className={`inline-flex items-center gap-1.5 px-2 py-0.5 rounded-md border text-[11px] font-mono font-medium uppercase tracking-wider ${cls} ${className}`}
    >
      <span className="w-1 h-1 rounded-full bg-current opacity-60" />
      {s}
    </span>
  );
}
